import {
  TRANSACTION_FETCH,
  TRANSACTION_FETCH_SUCCESS,
  TRANSACTION_FETCH_FAIL,
  TRANSACTION_SUMMARY_FETCH,
  TRANSACTION_SUMMARY_FETCH_SUCCESS,
  TRANSACTION_SUMMARY_FETCH_FAIL,
  TRANSACTION_MONTHLY_FETCH,
  TRANSACTION_MONTHLY_FETCH_SUCCESS,
  TRANSACTION_MONTHLY_FETCH_FAIL
} from '../actions';

const INIT_STATE = {
    transaction: [],
    loading: false,
    error: '',
    updatedate: false,
    totalAmount: 0,
    transactionSummary: 0,
    monthlyPeriod: [],
    monthlyAmount: [],
    transactionCharts: {period: [], amount: []}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TRANSACTION_FETCH:
            return { ...state, loading: true, error: '', updatedate: true};
        case TRANSACTION_FETCH_SUCCESS:
            return { ...state,
              loading: false,
              transaction: action.payload.transaction,
              totalAmount: action.payload.total,
              error: '',
              updatedate: false,
            };
        case TRANSACTION_FETCH_FAIL:
            return { ...state, loading: false, transaction: [], error: action.payload.message, totalAmount: 0 };

        case TRANSACTION_SUMMARY_FETCH:
            return { ...state, loading: true, error: ''};
        case TRANSACTION_SUMMARY_FETCH_SUCCESS:
            return { ...state, loading: false, transactionSummary: action.payload.transactionSummary, error: '' };
        case TRANSACTION_SUMMARY_FETCH_FAIL:
            return { ...state, loading: false, transactionSummary: 0, error: action.payload.message};

        case TRANSACTION_MONTHLY_FETCH:
            return { ...state, loading: true, error: '' };
        case TRANSACTION_MONTHLY_FETCH_SUCCESS:
            return { ...state, loading: false, error: '', monthlyPeriod: action.payload.period, monthlyAmount: action.payload.amount};
        case TRANSACTION_MONTHLY_FETCH_FAIL:
            return { ...state, loading: false, error: action.payload.message};
        default: return { ...state };
    }
}
